export const mutations = {
  SET_LAYERS(state, payload) {
    state.layers = state.layers.concat(payload)
  },
  UPDATE_LAYER(state, payload) {
    state.layers = state.layers.map(layer => {
      if (layer.uuid === payload.uuid) {
        return payload
      }
      return layer
    })
  },
  // Organization layers mutations
  SET_ORG_LAYERS(state, { orgId, layers }) {
    const existingLayers = state.orgLayers[orgId] || []
    const existingLayersMap = new Map(existingLayers.map(layer => [layer.uuid, layer]))

    const mergedLayers = layers.map(newLayer => {
      const existingLayer = existingLayersMap.get(newLayer.uuid)

      if (existingLayer && existingLayer.properties && existingLayer.properties.features) {
        // Preserve existing features when merging
        return {
          ...newLayer,
          properties: {
            ...newLayer.properties,
            features: existingLayer.properties.features,
            featureCollection: existingLayer.properties.featureCollection || {
              type: 'FeatureCollection',
              features: existingLayer.properties.features
            }
          }
        }
      }

      return newLayer
    })

    state.orgLayers = {
      ...state.orgLayers,
      [orgId]: mergedLayers
    }
  },
  ADD_ORG_LAYER(state, { orgId, layer }) {
    if (!state.orgLayers[orgId]) {
      state.orgLayers[orgId] = []
    }
    state.orgLayers[orgId] = [layer, ...state.orgLayers[orgId]]
  },
  UPDATE_ORG_LAYER(state, { orgId, layer }) {
    console.log('UPDATE_ORG_LAYER', state.orgLayers, layer)
    if (state.orgLayers[orgId]) {
      state.orgLayers[orgId] = state.orgLayers[orgId].map(l => {
        if (l.uuid === layer.uuid) {
          return layer
        }
        return l
      })
    }
  },
  UPDATE_ORG_LAYER_FEATURES(state, { orgId, layerId, features }) {
    if (state.orgLayers[orgId]) {
      state.orgLayers[orgId] = state.orgLayers[orgId].map(l => {
        if (l.uuid === layerId) {
          return {
            ...l,
            properties: {
              ...l.properties,
              features: features,
              featureCollection: {
                type: 'FeatureCollection',
                features: features
              }
            }
          }
        }
        return l
      })
    }
  },
  DELETE_ORG_LAYER(state, { orgId, layerId }) {
    if (state.orgLayers[orgId]) {
      state.orgLayers[orgId] = state.orgLayers[orgId].filter(layer => layer.uuid !== layerId)
    }
  },
  ADD_DATES(state, payload) {
    try {
      const existingDatesMap = new Map();

      if (state.dates && Array.isArray(state.dates)) {
        state.dates.forEach(date => {
          if (date && date.id) {
            existingDatesMap.set(date.id, date);
          }
        });
      }

      const payloadArray = Array.isArray(payload) ? payload : [payload];
      payloadArray.forEach(newDate => {
        if (!newDate || typeof newDate !== 'object') return;

        if (newDate.id === 'features' && newDate.layers && Array.isArray(newDate.layers)) {
          newDate.layers.forEach(templateLayer => {
            if (templateLayer && templateLayer.id) {
              const safeTemplateLayer = {
                id: templateLayer.id,
                name: templateLayer.name || 'Unknown Template',
                color: templateLayer.color || 'blue',
                dates: Array.isArray(templateLayer.dates) ? [...templateLayer.dates] : []
              };
              existingDatesMap.set(templateLayer.id, safeTemplateLayer);
            }
          });
        }
        else if (newDate.id) {
          const safeDateObject = {
            id: newDate.id,
            name: newDate.name || newDate.id || 'Unknown',
            color: newDate.color || 'blue',
            dates: Array.isArray(newDate.dates) ? [...newDate.dates] : []
          };
          existingDatesMap.set(newDate.id, safeDateObject);
        }
      });

      state.dates = Array.from(existingDatesMap.values());
    } catch (err) {
      console.error('Error in ADD_DATES mutation:', err);
    }
  },
  CLEAR_DATES(state) {
    state.dates = [];
  },
  SET_SELECTED_RANGE(state, payload) {
    state.selectedRange = payload
  },
  SET_SELECTED_FEATURE(state, { feature, coordinates, isVisible }) {
    state.selectedFeature = {
      feature,
      coordinates,
      isVisible
    }
  }
}
